export default "<nav class=\"navbar navbar-expand-lg headerFixed header pb-0\">\r\n    <p>{{name}}</p>\r\n</nav>\r\n\r\n";